import React from 'react';

const EyeIcon = ({size = 24, open = false}) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
    {!open && (
      <>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.88 9.88a3 3 0 1 0 4.24 4.24m-3.39-9.04c.42-.05.85-.08 1.27-.08 7 0 10 7 10 7-.45.96-1 1.86-1.67 2.68"/>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6.61 6.61A13.53 13.53 0 0 0 2 12s3 7 10 7c1.92 0 3.8-.55 5.39-1.61M2 2l20 20"/>
      </>
    )}
    {open && (
      <>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
      </>
    )}
  </svg>
);

export default EyeIcon;
